import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import * as actions from '../../actions/tag';
import s from './Tag.css';
import history from '../../core/history'
import Layout from '../../components/global/Layout';
import LoadMore from '../../components/common/LoadMore';
import Nav from '../../components/p_tag/Nav'
import Slide from '../../components/common/Slide'
import Column from '../../components/p_tag/Column'
import CourseCard from '../../components/common/CourseCard'
import { trackEventLog } from '../../core/utils'

class Tag extends React.Component {

  constructor(props) {
    super(props)
    this.loadTagMore = this.loadTagMore.bind(this)
  }

  componentDidMount() {
    const { tag } = this.props
    if (!tag.name) {
      history.replace('/not-found')
    }
  }

  loadTagMore() {
    const { tag, tagFetchMore } = this.props
    return tagFetchMore(tag.id, tag.courses[tag.courses.length - 1].rank)
  }

  render() {
    const { tag } = this.props
    const { serial } = tag;
    if (!tag.name) { // 用tag.subject判断是否存在该tag页
      return null
    }

    return (
      <Layout>
        <div className={s.wrapper}>
          <div className={s.content}>
            <div className={s.smallArea}>
              <Nav
                title={tag.pTag ? tag.pTag.name : tag.title}
                sub={tag.pTag && tag.pTag.subTag ? tag.pTag.subTag : []}
                curTagId={tag.id}
                fatherTag={tag.pTag || {}}
              />
              {tag.banner.length !== 0 ?
                <div className={s.slideContainer}>
                  <Slide banners={tag.banner} tagId={tag.id} inLocPrefix={'vp_h_'} inLocPosfix={`_tag${tag.id}`} />
                </div> : null}
            </div>
            <div className={s.serial}>
              {serial && serial.length !== 0 ?
                serial.map((course, idx) => (
                  <CourseCard
                    inLoc={'vertical'}
                    onClick={() => trackEventLog('xue_click', { unit: 'courseGroup', type: 'vertical', position: idx + 1, resource_id: course.id })}
                    showLogFuc={() => trackEventLog('xue_show', { unit: 'courseGroup', type: 'vertical', position: idx + 1, resource_id: course.id })}
                    key={`serial-course2-${idx}`}
                    className={s.courseCard}
                    serialCourse={course}
                    data={{}}
                  />
              )) : null}
            </div>
            {tag.column.length !== 0 ?
              <div className={tag.banner.length === 0 ? s.gap : ''}>
                {tag.banner.length !== 0 ?
                  <h2 className={s.title}>课程精选</h2> : null
                }
                {tag.column.map((column, inx) => (
                  <Column
                    tagId={tag.id}
                    data={column}
                    key={`tag_column_${column.id}`}
                    inx={inx}
                  />
                  ))}
              </div> : null
            }
            <div className={`${s.smallArea} ${!(tag.banner.length !== 0 || tag.column.length !== 0) && tag.courses.length !== 0 ? s.gap2 : ''} `}>
              {
                (tag.banner.length !== 0 || tag.column.length !== 0) && tag.courses.length !== 0 ?
                  <h2 className={s.allTitle}>全部课程</h2> : null
              }
              <div>
                {tag.courses.map((course, inx) => (
                  <CourseCard
                    inLoc={`${(tag.pTag && tag.pTag.id === tag.id) ? 'vp_all_tag' : 'subvp_tag'}${tag.id}`}
                    onClick={() => { trackEventLog(`w/tag/${tag.id}${(tag.pTag && tag.pTag.id === tag.id) ? '/all' : ''}/${inx}`) }}
                    key={`tag_course_${course.id}`}
                    className={s.courseCard}
                    data={course}
                  />
                ))}
              </div>
            </div>
            {
              tag.courses.length !== 0 ?
                <LoadMore onReachBottom={this.loadTagMore} hasMore={tag.hasMore} /> : null
            }
          </div>
        </div>
      </Layout>
    );
  }
}


Tag.propTypes = {
  tag: PropTypes.shape({
    banner: PropTypes.array,
    column: PropTypes.array,
    inited: PropTypes.bool.isRequired,
    serial: PropTypes.array,
  }).isRequired,
  tagFetchMore: PropTypes.func.isRequired,
};

Tag.defaultProps = {
  serial: [],
}

function mapStateToProps(state) {
  return {
    tag: state.tag,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Tag))




// WEBPACK FOOTER //
// ./src/routes/tag/Tag.js